import React from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import CardRow from 'design-system/CardRow';
import { IconShieldDone } from 'design-system/icons';
import { Button, CardView, rem, Spacer } from 'design-system';
import { SettingsItemIcon } from 'design-system/SettingsItemIcon';
import Status from 'design-system/Status';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { selectTotalBreaches } from '../selectors';
import { useFraudDetection } from './useFraudDetection';
const ActiveFraudDetectionCard = () => {
    const handlePress = useFraudDetection();
    const styles = useStyles(styleSet);
    const breachesInfo = useAppSelector(selectTotalBreaches);
    return (<CardView noMarginTop noMarginBottom>
      <Spacer h={16}/>
      <View style={styles.container}>
        <View style={styles.row}>
          <SettingsItemIcon iconSize={44}>
            <IconShieldDone />
          </SettingsItemIcon>
          <Spacer w={16}/>
          <View style={styles.flex}>
            <Status active activeText="Monitoring" inactiveText="Inactive"/>
            <Text Text-16>Fraud detection</Text>
          </View>
        </View>
      </View>
      <Spacer h={16}/>
      <View style={styles.line}/>
      <View style={styles.cardRowsContainer}>
        <CardRow title="Last scan" info={breachesInfo.lastScannedAt} small smallPadding/>
        <CardRow title="Number of breaches" info={breachesInfo.totalNumberOfBreaches} small smallPadding/>
      </View>
      <Spacer h={8}/>
      <View style={styles.container}>
        <Button brandReversed small square title="Check details" onPress={handlePress}/>
      </View>
      <Spacer h={16}/>
    </CardView>);
};
export default ActiveFraudDetectionCard;
const styleSet = createStyleSheets((colors) => ({
    container: {
        paddingHorizontal: rem(16),
    },
    row: {
        alignItems: 'center',
        flexDirection: 'row',
    },
    flex: {
        flex: 1,
    },
    line: {
        height: 1,
        width: '100%',
        backgroundColor: colors.background.dark,
    },
    cardRowsContainer: {
        paddingVertical: rem(4),
    },
}));
